// import {SelectItem} from 'primeng';
import Handsontable from 'handsontable';
import {SelectItem} from 'primeng/api';

export class Utils {

    public static getUrlParams(search): any {
        const hashes = search.slice(search.indexOf('?') + 1).split('&');
        const params = {};
        hashes.map(hash => {
            const [key, val] = hash.split('=');
            params[key] = decodeURIComponent(val);
        });

        return params;
    }

    public static createDateWithTime(timeString: string): Date {
      const [hours, minutes] = timeString.split(':').map(Number);
      const now = new Date();

      return new Date(
        now.getFullYear(),
        now.getMonth(),
        now.getDate(),
        hours,
        minutes,
        0,
        0
      );
    }


}
